import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '@web/components/Toggle';
import {formatField, formatKey} from '@web/lib/formaters';
// import UserAvatar from '@web/components/UserAvatar';

JsonViewer.propTypes = {
  json: PropTypes.object.isRequired,
  indent: PropTypes.number,
};

function JsonViewer(props) {
  return <Toggle trigger={props.children}>
    <div
      className="json-viewer bgx space space-col"
      style={{width: "1000px"}}
    >
      {Object.entries(props.json || {}).map(([key, value]) => {
        if (key === "userId") return null;
        return <div key={key} className="space space-center-y gap-10">
          {formatKey(key, value, props.indent)}
          {formatField(key, value, props.indent + 1)}
        </div>;
      })}
      <div className="item-marker"></div>
    </div>
  </Toggle>
}

export default JsonViewer;
